// THIS FILE IS GENERATED, DO NOT MODIFY MANUALLY. ##checksum##: 1705337393
import { createAction } from 'typesafe-actions';

export const setFlag = createAction('FLAGS/SET_FLAG')<{ flag: string; value: boolean }>();
